import React from 'react'
import { useDataLayer } from '../../hooks/useDataLayer'
import DynamicLink from '../atoms/DynamicLink'

const StorungMelden = ({ isMobile = false, heading, body, phoneNumber }) => {
  const dataLayer = useDataLayer()

  return (
    <div className={isMobile ? 'xl:hidden' : 'hidden xl:flex flex-col'}>
      <div className="w-4.5 h-4.5 md:w-3.5 md:h-3.5 xl:w-4.5 xl:h-4.5 mb-1 rounded-full bg-red" />

      <DynamicLink
        link={heading}
        className="underline text-[15px] font-bold leading-normal mb-3 transition-colors hover:text-red-as"
      />

      <div className="mb-11 lg:mb-16">
        <div
          className="text-[15px] mb-6 link-wrapper"
          dangerouslySetInnerHTML={{ __html: body }}
        />
        <p className="text-[23px] font-bold text-red">
          <a
            href={`tel:${phoneNumber}`}
            onClick={() =>
              dataLayer.push({
                eventCategory: 'Telefonnummern',
                eventAction: 'click',
                eventLabel: phoneNumber,
                event_location: null,
              })
            }
          >
            {phoneNumber}
          </a>
        </p>
      </div>
    </div>
  )
}

export default StorungMelden
